export const formatCurrencyAmount = (amount: number, currency: string): string =>
  new Intl.NumberFormat(undefined, {
    style: "currency",
    currency: currency || "USD",
  }).format(amount);

export const getIntlCurrencyDisplayName = (locale: string, isoCode: string, capitalize: boolean) => {
  const currencyName = new Intl.NumberFormat(locale, {
    style: "currency",
    currency: isoCode,
    currencyDisplay: "name",
  })
    .formatToParts()
    .filter((part) => part.type === "currency")[0].value;

  // Capitalize currency name according to locale
  if (capitalize === true) return currencyName.toLocaleUpperCase(locale);

  return currencyName;
};

export const getCurrencyName = (locale: string, isoCurrency: string) => {
  const displayNames = new Intl.DisplayNames(locale, { type: "currency" });
  const currencyName = displayNames.of(isoCurrency);
  return currencyName;
};
